package one.healthium.health_advice.data

import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.withContext
import kotlinx.serialization.json.Json
import one.healthium.base.coroutines.IO
import one.healthium.health_advice.domain.HealthAdviceModel
import one.healthium.health_advice.domain.HealthAdviceRepository
import one.primehealth.app.BaseAppResourceProvider

class AppHealthAdviceRepository(
    private val json: Json,
    private val appResourceProvider: BaseAppResourceProvider,
) : HealthAdviceRepository {
    override suspend fun getRulesSet(): HealthAdviceModel {
        return withContext(Dispatchers.IO) {
            // TODO memory cache
            val bytes = appResourceProvider.readBytes("files/symptoms/rules.json")
            json.decodeFromString<HealthAdviceModel>(bytes.decodeToString())
        }
    }
}